var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card__content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c(
          "div",
          { staticClass: "table-responsive" },
          [
            _c("vue-good-table", {
              attrs: {
                mode: "remote",
                columns: _vm.columns,
                "pagination-options": {
                  enabled: true,
                  perPage: 10,
                  nextLabel: "siguiente",
                  prevLabel: "anterior",
                  rowsPerPageLabel: "Registros por página",
                  ofLabel: "de",
                  allLabel: "Todo",
                  dropdownAllowAll: true,
                  perPageDropdownEnabled: true,
                  perPageDropdown: [10, 20, 30, 40, 50]
                },
                totalRows: _vm.form.pagination.total,
                rows: _vm.registros,
                "search-options": {
                  enabled: false,
                  placeholder: "Buscar..."
                },
                styleClass: "vgt-table",
                "row-style-class": _vm.rowStyleClassFn
              },
              on: {
                "on-page-change": _vm.onPageChange,
                "on-per-page-change": _vm.onPerPageChange
              },
              scopedSlots: _vm._u([
                {
                  key: "table-column",
                  fn: function(props) {
                    return [
                      props.column.label == "acciones"
                        ? _c("span", [
                            _vm._v("\n              Acciones\n            ")
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(props.column.label) +
                                "\n            "
                            )
                          ])
                    ]
                  }
                },
                {
                  key: "table-row",
                  fn: function(props) {
                    return [
                      props.column.field == "contenido"
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  props.row.contenido.substring(0, 50) + "..."
                                ) +
                                "\n            "
                            )
                          ])
                        : props.column.field == "acciones"
                        ? _c("span", [
                            _c(
                              "button",
                              {
                                staticClass: "btn-danger",
                                attrs: {
                                  tooltip: "Descargar PDF",
                                  type: "button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.botonDescargarPdf(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-file-pdf-o" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-info",
                                attrs: { tooltip: "Editar", type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.botonEditar(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-edit" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class:
                                  props.row.estado == "I"
                                    ? "btn-success"
                                    : "btn-danger",
                                attrs: {
                                  tooltip:
                                    props.row.estado == "I"
                                      ? "Re-activar"
                                      : "Anular",
                                  type: "button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.botonEliminar(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash" })]
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(props.formattedRow[props.column.field]) +
                                "\n            "
                            )
                          ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f128c88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f128c88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/terminos-condiciones/ListaTerminosCondiciones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1f128c88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/terminos-condiciones/ListaTerminosCondiciones.vue
// module chunks = 0